<aside class="dashboard-sidebar">
  <nav class="sidebar-nav">
    @for (item of navItems; track item.label) {
      @if (item.route) {
        <a
          class="nav-item"
          [routerLink]="item.route"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: item.route === '/' }"
        >
          <i [class]="'bi ' + item.icon"></i>
          <span>{{ item.label }}</span>
        </a>
      } @else {
        <div class="nav-item">
          <i [class]="'bi ' + item.icon"></i>
          <span>{{ item.label }}</span>
        </div>
      }
    }

    @if (!activeTenantSlug) {
      <a class="nav-item" routerLink="/tenants" routerLinkActive="active">
        <i class="bi bi-building"></i>
        <span>Tenant</span>
      </a>
    } @else {
      <button type="button" class="nav-item tenant-toggle" (click)="toggleTenantSection()">
        <i class="bi bi-building"></i>
        <span>{{ activeTenantName }}</span>
        <i class="bi bi-chevron-down chevron" [class.rotated]="tenantExpanded"></i>
      </button>

      <div class="tenant-submenu" [class.open]="tenantExpanded">
        <div class="tenant-submenu-inner">
          @for (child of tenantChildren; track child.route) {
            <a
              class="nav-subitem"
              [routerLink]="child.route"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: child.exact }"
            >
              <i [class]="'bi ' + child.icon"></i>
              <span>{{ child.label }}</span>
            </a>
          }
        </div>
      </div>
    }
  </nav>
</aside>
